import React from 'react';
import PropTypes from 'prop-types';
import { getColor } from 'core/utils/Styles';

const UserIcon = ({ stroke = getColor('dustyGray'), ...props }) => (
	<svg width="20" height="22" viewBox="0 0 20 22" stroke={stroke} fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" {...props}>
		<path d="M14.6 6a5 5 0 1 1-10 0 5 5 0 0 1 10 0zM1 21v-1.4a8.6 8.6 0 0 1 17.3 0V21H1z"/>
	</svg>
);

UserIcon.propTypes = {
	stroke: PropTypes.string,
};

export default UserIcon;
